import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchCollectionRequest({ page, limit, filters = [] }) {
  try {
    const url = paths.getCollectionRequest();

    const payload = {
      input: {
        offset: page * limit,
        limit: limit,
        filters: filters,
      },
    };

    const response = await axiosInstance.post(url, payload);
    return response.data?.data || [];
  } catch (error) {
    console.error("Collection request failed:", error?.response?.data || error);
    return Promise.reject(error);
  }
}

const useCollectionRequest = () => {
  return useMutation({
    mutationFn: fetchCollectionRequest,
  });
};

export { useCollectionRequest };